import React from 'react';

import Roles from 'constants/UserRoles';

import DataList from 'components/ui/DataList';
import DataPoller from 'components/ui/DataPoller';

import LocationActionCreators from 'actions/LocationActionCreators';
import LocationSearch from 'components/site/location-search';
import LocationStore from 'stores/LocationStore';

import ConfirmModal from 'components/ui/modals/ConfirmModal';
import _ from 'underscore';
import SessionStore from 'stores/SessionStore';
import { withTranslation } from 'react-i18next';
import { titleize } from 'underscore.string';
import Mapping from './Mapping';
import CreateLocationModal from './CreateLocationModal';

const CAN_CREATE_LOCATIONS = [
  Roles.LOCATIONS_MANAGER,
  Roles.LOCATIONS_ADMIN,
  Roles.GOD,
];

const deleteRoles = [Roles.LOCATIONS_MANAGER, Roles.LOCATIONS_ADMIN, Roles.GOD];

function mapRoles() {
  const roles = SessionStore.getUserRoles();
  const canDelete = roles.some((r) => deleteRoles.includes(r));

  return {
    canDelete,
  };
}

class List extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      user: SessionStore.getUser(),
      errors: {},
      locations: [],
      totalPages: 10,
      showCreateLocationModal: false,
      showLocationSearch: true,
      filters: {
        page: 1,
        per_page: 25,
        paginate: true,
        sort_by: '_id',
      },
      ...mapRoles(),
    };

    const { canDelete } = this.state;
    const canEdit = false;

    this.columnMappings = Mapping.columns.map((col) => {
      if (col.type === 'customActions') {
        return {
          ...col,
          formatExtraData: {
            onDelete: this.handleDelete,
            canDelete,
            canEdit,
          },
        };
      }
      return col;
    });
  }

  componentDidMount() {
    LocationStore.addChangeListener(this.handleLocationStoreChange);
  }

  componentWillUnmount() {
    LocationStore.removeChangeListener(this.handleLocationStoreChange);
  }

  handleLocationStoreChange = () => {
    const locationList = LocationStore.getLocationList() || {};
    const locations = locationList.items || [];
    const location = LocationStore.getLocation();
    const pages = locationList.pages;
    const createLocationError = LocationStore.getCreateLocationError();
    const errors = this.state.errors;
    errors.createLocationError = createLocationError;

    if (location && location._id) {
      window.location.href = `/locations/${location._id}`;
    } else {
      this.setState({
        locations,
        totalPages: pages,
        errors,
      });
    }
  };

  handlePaginationSelect = (page) => {
    this.setState(
      (prevState) => ({
        filters: {
          ...prevState.filters,
          page,
        },
      }),
      () => {
        LocationActionCreators.getLocations(this.state.filters); // Find a way to add this to the poller component
      },
    );
  };

  canCreateLocations() {
    // Only location managers and admins can create locations
    return this.state.user.roles.some((r) => CAN_CREATE_LOCATIONS.includes(r));
  }

  handleHide = () => {
    LocationStore.clearCreateLocationError();
    this.setState(
      {
        showCreateLocationModal: false,
      },
      () => {
        LocationActionCreators.getLocations(this.state.filters);
      },
    );
  };

  handleCreateLocation = async (newLocation) => {
    await LocationActionCreators.createLocation(newLocation);
    this.setState({ showCreateLocationModal: false });
  };

  handleShowCreateLocationModal = () =>
    this.setState({ showCreateLocationModal: true });

  handleConfirmDelete = () => {
    LocationActionCreators.removeLocation(this.state.currentLocation._id);
    this.handleHideConfirmModal();
  };

  handleDelete = (row) => {
    this.setState({
      currentLocation: row,
      showConfirmModal: true,
    });
  };

  handleHideConfirmModal = () => {
    this.setState({
      showConfirmModal: false,
      currentLocation: null,
    });
  };

  clearLocationSearch = () => {
    const { filters } = this.state;
    const clearedSearch = _.omit(filters, 'search');
    LocationActionCreators.getLocations(clearedSearch);
  };

  handleLocationSearch = (item) => {
    const { filters } = this.state;
    filters.search = item.address;
    LocationActionCreators.getLocations(filters);
  };

  render() {
    const { t } = this.props;
    return (
      <div className="p-4 bg-white rounded shadow">
        <DataPoller
          action={() => LocationActionCreators.getLocations(this.state.filters)}
        />
        <div className="flex mt-4 mb-4">
          <div className="w-1/3">
            {this.state.showLocationSearch && (
              <LocationSearch
                placeholder={t('LOCATION_SEARCH')}
                handleLocationSearch={this.handleLocationSearch}
              />
            )}
          </div>
          <div>
            <button
              className="button button-green ml-2"
              onClick={this.clearLocationSearch}
            >
              {titleize(t('CLEAR'))}
            </button>
          </div>
        </div>
        <div className="flex items-center header">
          <h3 className="mt-0 mb-0 mr-2">{t('LOCATIONS')}</h3>
          {this.canCreateLocations() && (
            <button
              title={t('CREATE_LOCATION')}
              className="flex items-center text-white button button-circle bg-green"
              onClick={this.handleShowCreateLocationModal}
            >
              <i className="mr-0 fa fa-plus" />
            </button>
          )}
        </div>
        <CreateLocationModal
          onHide={this.handleHide}
          show={this.state.showCreateLocationModal}
          onCreate={this.handleCreateLocation}
          error={this.state.errors.createLocationError}
        />
        <DataList
          striped
          showHeaders
          paginate
          data={this.state.locations}
          columns={this.columnMappings}
          pages={this.state.totalPages}
          page={this.state.filters.page}
          onPaginationSelect={this.handlePaginationSelect}
        />
        <ConfirmModal
          show={this.state.showConfirmModal}
          title={t('DELETE_CONFIRMATION')}
          message={t('DELETE_LOCATION_CONFIRMATION')}
          onConfirm={this.handleConfirmDelete}
          onHide={this.handleHideConfirmModal}
        />
      </div>
    );
  }
}

export default withTranslation()(List);
